import { useReducedMotion } from "framer-motion";
import { usePauseWhenOffscreen } from "@/hooks/use-pause-when-offscreen";

export const AmbientField = () => {
  const reduced = useReducedMotion();
  const ref = usePauseWhenOffscreen<HTMLDivElement>();

  if (reduced) return null;

  return (
    <div
      ref={ref}
      aria-hidden="true"
      role="presentation"
      className="hidden md:block pointer-events-none fixed inset-0 -z-10 overflow-hidden"
    >
      <div className="absolute -top-[20%] -left-[15%] size-[55vw] min-w-[480px] rounded-full bg-accent/[0.08] blur-3xl animate-drift-slow" />
      <div className="absolute top-[30%] -right-[20%] size-[60vw] min-w-[520px] rounded-full bg-primary/[0.07] blur-3xl animate-drift-slow-alt" />
      <div className="absolute -bottom-[20%] left-[20%] size-[45vw] min-w-[420px] rounded-full bg-accent/[0.05] blur-3xl animate-drift-slow [animation-delay:-12s]" />
    </div>
  );
};
